import { View, Text } from '@react-pdf/renderer';
import { invoiceItemsStyle } from './style';

type InvoiceItem = {
    title: string;
    subtitle: string;
    quantity: string;
    rate: string;
    tax: string;
    amount: string;
};

type Props = {
    items: InvoiceItem[];
    subtotal: string;
    tax: string;
    total: string;
    amountDue: string;
    note?: string;
};

export const InvoiceItems = ({ items, subtotal, tax, total, amountDue }: Props) => {
    return (
        <View style={invoiceItemsStyle.container}>
            <View style={invoiceItemsStyle.tableHeader}>
                <Text style={[invoiceItemsStyle.headerCell, invoiceItemsStyle.descriptionHeader]}>Item Details</Text>
                <Text style={[invoiceItemsStyle.headerCell, invoiceItemsStyle.qtyHeader]}>Quantity</Text>
                <Text style={[invoiceItemsStyle.headerCell, invoiceItemsStyle.rateHeader]}>Rate</Text>
                <Text style={[invoiceItemsStyle.headerCell, invoiceItemsStyle.taxHeader]}>Tax</Text>
                <Text style={[invoiceItemsStyle.headerCell, invoiceItemsStyle.amountHeader]}>Amount</Text>
            </View>

            {items.map((item, index) => (
                <View key={index} style={invoiceItemsStyle.tableRow}>
                    <View style={invoiceItemsStyle.descriptionCell}>
                        <Text style={invoiceItemsStyle.descriptionTitle}>{item.title}</Text>
                        <Text style={invoiceItemsStyle.descriptionSubtitle}>{item.subtitle}</Text>
                    </View>
                    <Text style={invoiceItemsStyle.qtyCell}>{item.quantity}</Text>
                    <Text style={invoiceItemsStyle.rateCell}>{item.rate}</Text>
                    <Text style={invoiceItemsStyle.taxCell}>{item.tax}</Text>
                    <Text style={invoiceItemsStyle.amountCell}>{item.amount}</Text>
                </View>
            ))}

            <View style={invoiceItemsStyle.totalsSection}>
                <View style={invoiceItemsStyle.totalRow}>
                    <Text style={invoiceItemsStyle.totalLabel}>Subtotal</Text>
                    <Text style={invoiceItemsStyle.totalValue}>{subtotal}</Text>
                </View>

                <View style={invoiceItemsStyle.totalRow}>
                    <Text style={invoiceItemsStyle.totalLabel}>Tax</Text>
                    <Text style={invoiceItemsStyle.totalValue}>{tax}</Text>
                </View>

                <View style={invoiceItemsStyle.totalLastRow}>
                    <Text style={invoiceItemsStyle.totalLabel}>Total</Text>
                    <Text style={invoiceItemsStyle.totalValue}>{total}</Text>
                </View>

                <View style={invoiceItemsStyle.amountDueRow}>
                    <Text style={invoiceItemsStyle.amountDueLabel}>Amount Due</Text>
                    <Text style={invoiceItemsStyle.amountDueValue}>{amountDue}</Text>
                </View>
            </View>
        </View>
    );
};
